import PremixLabGrid from "./pages/Dashboard/PremixGrid";
import RjsfSampleForm from "./Containers/Forms/LabSampleSections/RjsfSampleForm";
import NotificationPage from "./pages/Notification Page/NotificationPage";

export const ApplicationRoutes = [
  {
    key: "premix",
    title: "Premix Grid",
    path: "/premix/:categoryId",
    enabled: true,
    component: PremixLabGrid,
  },

  {
    key: "premix-details-individual",
    title: "Premix Edit Form",
    path: "/premix/:categoryId/details/:id",
    enabled: true,
    component: RjsfSampleForm,
  },
  {
    key: "frk",
    title: "FRK Grid",
    path: "/frk/:categoryId",
    enabled: true,
    component: PremixLabGrid,
  },
  {
    key: "frk-details-individual",
    title: "FRK Edit Form",
    path: "/frk/:categoryId/details/:id",
    enabled: true,
    component: RjsfSampleForm,
  },
  {
    key: "Miller",
    title: "Miller Grid",
    path: "/Miller/:categoryId",
    enabled: true,
    component: PremixLabGrid,
  },
  {
    key: "Miller-details-individual",
    title: "Miller Edit Form",
    path: "/Miller/:categoryId/details/:id",
    enabled: true,
    component: RjsfSampleForm,
  },
  {
    key: "default route",
    title: "default",
    path: "/",
    enabled: true,
    component: PremixLabGrid,
  },
  {
    key:"notificationPage",
    title:"notification Page",
    path:"/notification",
    enabled:true,
    component:NotificationPage
  },
];
